import { api } from './client';

export interface AIPrompt {
  id: string;
  key: string;
  name: string;
  description: string | null;
  system_prompt: string;
  user_template: string;
  model: string | null;
  temperature: number;
  max_tokens: number;
  updated_at: string;
  placeholders: string[];
}

export const aiPromptsApi = {
  list: () => api.get<AIPrompt[]>('/api/v1/ai-prompts').then(r => r.data),
  update: (key: string, p: Partial<Pick<AIPrompt,
    'name' | 'description' | 'system_prompt' | 'user_template' | 'model' | 'temperature' | 'max_tokens'>>) =>
    api.patch<AIPrompt>(`/api/v1/ai-prompts/${key}`, p).then(r => r.data),
  reset: (key: string) =>
    api.post<AIPrompt>(`/api/v1/ai-prompts/${key}/reset`).then(r => r.data),
};
